import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const CHANGE_BO_PARENT_ACCOUNT_REQUEST = 'CHANGE_BO_PARENT_ACCOUNT_REQUEST';
export const CHANGE_BO_PARENT_ACCOUNT_SUCCESS = 'CHANGE_BO_PARENT_ACCOUNT_SUCCESS';
export const CHANGE_BO_PARENT_ACCOUNT_FAILURE = 'CHANGE_BO_PARENT_ACCOUNT_FAILURE';

function requestChangeBoParentAccount(name, changeDetails) {
  return {
    type: CHANGE_BO_PARENT_ACCOUNT_REQUEST,
    name,
    changeDetails
  };
}

function receiveChangeBoParentAccount(accountId, statementContainer) {
  return {
    type: CHANGE_BO_PARENT_ACCOUNT_SUCCESS,
    accountId,
    statementContainer
  };
}

function rejectChangeBoParentAccount(accountId) {
  return {
    type: CHANGE_BO_PARENT_ACCOUNT_FAILURE,
    accountId
  };
}

export function changeBoParent(accountId, changeDetails) {
  return (dispatch) => {
    dispatch(requestChangeBoParentAccount(accountId, changeDetails));
    const promise = () => ApiService
      .updateWithholdingStatementBoParent(accountId, changeDetails)
      .then((response) => {
        dispatch(receiveChangeBoParentAccount(accountId, response.data));
        if (response.data) {
          toastr.success('Save Successful', 'Owner Parent change successful');
        } else {
          toastr.error('Save Failed', 'There was an unexpected response when changing the Owner parent');
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(rejectChangeBoParentAccount(accountId)), true)));

    return promise();
  };
}
